import { getHomePath } from "@shared/common/node/condition";
import type { ExternalSiteCheckRule } from "../../types";
import { SITE_TYPE } from "./const";

const wordpress: ExternalSiteCheckRule = {
  type: SITE_TYPE,

  checkPage({ url, target, siteUrl }) {
    if (target.value === "HOME" && url.pathname === getHomePath(siteUrl)) {
      return true;
    }

    return false;
  },
};

export default wordpress;
